export const mail = {
  '站内信': 'Notifications',
  '返回': 'Back',
  '有未读信息': '{amount} unread',
  '全部标记为已读': 'Read All',
  '隐藏已读消息': 'Hide read',
  '展开': 'Show',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/en.js